import React from 'react'

import { AsideContent, AsideContentProps } from './AsideContent/AsideContent'

import s from './ArticleOrStoryLayout.module.scss'

export type ArticleOrStoryLayoutProps = {
  children: React.ReactNode
  asideContentProps?: AsideContentProps
}

export const ArticleOrStoryLayout: React.FC<ArticleOrStoryLayoutProps> = ({
  children,
  asideContentProps,
}) => {
  return (
    <div className={s.ArticleOrStoryLayout}>
      {children}
      <AsideContent {...asideContentProps} />
    </div>
  )
}
